<template>
  <div class="col-md-12 bg-white" id="staffMainPage" :class="checkMobileStatus ? 'mobile-activity' : 'web-view'">


    <div class="nav-button-container py-md-2" :style="{background: uiVariable.color.background2}">
      <div class="mx-md-4 bg-white rounded-pill nav-base p-2">
        <navButton @changePageFromChild="changePage" :passCurrentPage="currentPage"
                   :passBroadcastAlert="paramBroadcastAlert"/>
      </div>
    </div>

    <div class="main-content-container " style="display: block"
         :class="(currentPage === 'travelDeclaration' || currentPage === 'declarationForm') ? 'specific' : ''">

      <div v-if="isCenter"
           :class="isLeft && isRight ? 'normal' :  ((isLeft && !isRight) || (!isLeft && isRight)) ? 'only-left' : 'full-width'">
        <div class="content-container" :id="tourIDName2">
          <ActivityFeed :is="obj_SelectedComponent"
                        :passPortfolioID="portfolioID"
                        :passSelectedFiles="grapeSelectedFiles"
                        @paramPlannerProgress="changeToPlannerProgress"
                        @uploadVideo="uploadVideo"
                        :ppParamData="obj_ppData"
                        :dmParamData="arrobj_dmList"
                        :passTourData="tourType"
                        v-if="isRerender"></ActivityFeed>
        </div>
      </div>

      <div
          v-show="checkMobileStatus && !isMobileClickCreate && userType !== 'Parent' && (currentPage === 'feed' || currentPage === 'broadcast')"
          style="position: fixed; z-index: 999; bottom: 50px; width: 100%;">
        <!--<button class="btn sans-font-style&#45;&#45;size-12" style="background: #426DFF; color: #ffffff; width: 100%;"-->
                <!--@click="mobileShowLibrary()">{{ lang("Create") + lang("Post") }}-->
        <!--</button>-->
        <button class="btn sans-font-style--size-12" style="background: #426DFF; color: #ffffff; width: 100%;"
                @click="handleCreate()">{{ lang("Create") + lang("Post") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import $ from 'jquery';
import {lang} from '../../locale/index';
import navButton from "../../components/NavButton";
import staffLibrary from "../../components/MainLibraryComponent";
import staffNotification from "../../components/MainNotificationComponent";
import activityFeed from "../../pages/activityJapan/component/activityFeed";
import staffMoment from "../../pages/StaffMoment";
import staffTempMoment from "../../pages/StaffTempMoment";
import staffBroadcast from "../../pages/StaffBroadcast";
import staffReport from "../../pages/termlyReport/TermlyReport";
import staffPlanner from "../../pages/PlannerAssignStudent";
import staffClassPlanner from "@/pages/PlannerAssignClass";
import staffAttendance from "../../pages/AttendanceList";
import staffEvent from "../../pages/StaffEvent";
import parentTravelDeclaration from "../../pages/ParentTravelDeclaration";
import staffDM from "../../pages/StaffDM";
import staffPlannerProgress from "../../pages/PlannerStudentProgress";
import staffDailyRoutine from "../../pages/DailyRoutine";
import tempStaffBilling from "../../pages/TempStaffBilling";
import dailyRoutineParent from "../../pages/DailyRoutineParent";
import staffTermlyReportList from "../../pages/StaffTermlyReportList";
import parentDeclarationForm from "../../pages/ParentDeclarationForm";
import survey from "../../pages/Survey";
import K2Button from "../../uiComponents/k2Button/k2Button";
import K2Text from "../../uiComponents/k2Text/k2Text";
import K2Modal from "../../uiComponents/k2Modal/k2Modal";
import NewActivity from "./newActivityPage";
import K2Row from "../../uiComponents/k2Row/k2Row";
import "./activity.scss";
import uiVariable from "../../config/uiVariable";
import ActivityFeed from "./component/activityFeed";
import DataSource from "../../data/datasource";
// import * as jQuery from "../../components/signalR/jquery-3.5.1";
// import * as signalR from "../../components/signalR/jquery.signalR-2.4.1";
export default {
  name: "ActivityJapanPage",
  components: {
    ActivityFeed,
    K2Row,
    NewActivity,
    K2Modal,
    K2Text,
    K2Button,
    navButton,
    staffLibrary,
    staffNotification
  },
  data() {
    return {
      isLeft: true, // decide want to show left container or not
      isCenter: true, // decide want to show center container or not
      isRight: true, // decide want to show right container or not
      obj_SelectedComponent: false,
      isRerender: true,
      checkMobileStatus: false,
      isMobileClickCreate: false,
      paramBroadcastAlert: false,
      currentPage: '',
      portfolioID: '',
      userType: '',
      tourType: '',
      uiVariable: uiVariable,

      grapeSelectedFiles: [],
      arrobj_dmList: [],

      obj_ppData: {},

      //vue tour
      //https://github.com/pulsardev/vue-tour
      tourIDName1: '',
      tourIDName2: '',
      broadcastPageVueTourOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: 'Skip tour',
          buttonPrevious: 'Previous',
          buttonNext: 'Next',
          buttonStop: 'Finish'
        }
      },
      broadcastPageVueTourCallBacks: {
        onPreviousStep: this.broadcastPageVueTourCallBacksPreviousSteps,
        onNextStep: this.broadcastPageVueTourCallBacksNextSteps
      },
      broadcastPageVueTour: [
        {
          target: '#v-step-broadcastCreateNewBroadcast',
          content: `<div class="broadcastPageTourDiv">Step 1 / 2 <br> Select image or without image then click Post button <br> Then will prompt out modal and fill up those fields.</div>`,
          params: {
            placement: 'right',
            enableScrolling: false
          }
        },
        {
          target: '#v-step-broadcastEditBroadcast',
          content: `<div class="broadcastPageTourDiv">Step 2 / 2 <br> Select 1 post that created by you. <br> Then click the post under broadcast details there it will prompt out modal that can edit/delete.</div>`,
          params: {
            placement: 'bottom',
            enableScrolling: false
          }
        },
      ],

      feedPageVueTourOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: 'Skip tour',
          buttonPrevious: 'Previous',
          buttonNext: 'Next',
          buttonStop: 'Finish'
        }
      },
      feedPageVueTourCallBacks: {
        onPreviousStep: this.feedPageVueTourCallBacksPreviousSteps,
        onNextStep: this.feedPageVueTourCallBacksNextSteps
      },
      feedPageVueTour: [
        {
          target: '#v-step-feedCreateNewFeed',
          content: `<div class="broadcastPageTourDiv">Step 1 / 2 <br> Select at least 1 image then click Post button <br> Then will prompt out modal and fill up those fields.</div>`,
          params: {
            placement: 'right',
            enableScrolling: false
          }
        },
        {
          target: '#v-step-feedEditFeed',
          content: `<div class="broadcastPageTourDiv">Step 2 / 2 <br> Select the 3 dot on top right with the post. <br> Then can select edit or delete post.</div>`,
          params: {
            placement: 'bottom',
            enableScrolling: false
          }
        },
      ],
      //vue tour
      modal: null,
    };
  },
  created() {
    this.userType = Cookies.get('userTypeSession');
    window.addEventListener('resize', this.isMobile);
  },
  destroyed() {
    window.removeEventListener('resize', this.isMobile);
  },
  methods: {
    lang,

    changePage(val) {
      if (this.$route.query.tour === undefined) {
        this.tourType = "";
      }
      // $(".feed-parent-details-container").remove();

      this.currentPage = val;

      this.isCenter = true;
      this.isLeft = true;
      this.isRight = true;
      // different page set different component
      if (this.currentPage === "feed") {
        this.obj_SelectedComponent = activityFeed;
      } else if (this.currentPage === "moment") {
        this.isRight = false;

        if (this.userType === "Parent") {
          // this.isLeft = false;
        }

        if (this.userType === "Parent") {
          this.obj_SelectedComponent = staffTempMoment;
        } else {
          this.obj_SelectedComponent = staffMoment;
        }
        // this.obj_SelectedComponent = staffMoment;
      } else if (this.currentPage === "broadcast") {
        this.isRight = false;

        if (this.userType === "Parent") {
          this.isLeft = false;
        }

        this.obj_SelectedComponent = staffBroadcast;
      } else if (this.currentPage === "report") {
        this.isLeft = false;
        this.isRight = false;
        this.obj_SelectedComponent = staffReport;
      } else if (this.currentPage === "planner") {
        this.isLeft = false;
        this.isRight = false;
        this.obj_SelectedComponent = staffPlanner;
      } else if (this.currentPage === "classPlanner") {
        this.isLeft = false;
        this.isRight = false;
        this.obj_SelectedComponent = staffClassPlanner;
      } else if (this.currentPage === "attendance") {
        this.isLeft = false;
        this.isRight = false;
        this.obj_SelectedComponent = staffAttendance;
      } else if (this.currentPage === "event") {
        this.isLeft = false;
        this.isRight = false;
        this.obj_SelectedComponent = staffEvent;
      } else if (this.currentPage === "travelDeclaration") {
        this.isLeft = false;
        this.isRight = false;
        this.obj_SelectedComponent = parentTravelDeclaration;
      } else if (this.currentPage === "dm") {
        this.isLeft = false;
        this.obj_SelectedComponent = staffDM;
      } else if (this.currentPage === "plannerProgress") {
        this.isLeft = false;
        this.isRight = false;
        this.obj_SelectedComponent = staffPlannerProgress;
      } else if (this.currentPage === "dailyRoutine") {
        this.isLeft = false;
        this.isRight = false;
        this.obj_SelectedComponent = staffDailyRoutine;
      } else if (this.currentPage === "ebilling") {
        this.isLeft = false;
        this.isRight = false;
        this.obj_SelectedComponent = tempStaffBilling;
      } else if (this.currentPage === "dailyRoutineParent") {
        this.isLeft = false;
        this.isRight = false;
        this.obj_SelectedComponent = dailyRoutineParent;
      } else if (this.currentPage === "termlyReportList") {
        this.isLeft = false;
        this.isRight = false;
        this.obj_SelectedComponent = staffTermlyReportList;
      } else if (this.currentPage === "declarationForm") {
        this.isLeft = false;
        this.isRight = false;
        this.obj_SelectedComponent = parentDeclarationForm;
      } else if (this.currentPage === "survey") {
        this.isLeft = false;
        this.isRight = false;
        this.obj_SelectedComponent = survey;
      }

      if (this.checkMobileStatus) {
        this.isMobileClickCreate = false;
        this.isLeft = false;
        this.isRight = false;
      }
    },

    rerenderComponent(val) {
      if (val) {
        this.isRerender = false;

        this.$nextTick(() => {
          // Add the component back in
          this.isRerender = true;
        });

        if (this.checkMobileStatus) {
          this.changePage('feed');
        }
      }
    },

    selectedFiles(getFiles) {
      this.grapeSelectedFiles = getFiles;
    },

    /*#region show Drop Zone Functions*/
    showDropZone() {
      $("#div_DropZone").css({
        "visibility": "visible",
        "opacity": "1"
      });
    },
    hideDropZone() {
      $("#div_DropZone").css({
        "visibility": "hidden",
        "opacity": 0
      });
    },
    /*#endregion*/

    isMobile() {
      let screenWidth = window.innerWidth;
      if (screenWidth <= 770) {
        this.checkMobileStatus = true;
        // return true;
      } else {
        this.checkMobileStatus = false;
        // return false;
      }
    },

    mobileShowNotificationList(val) {
      if (val) {
        this.isMobileClickCreate = true;
        this.isLeft = false;
        this.isCenter = false;
        this.isRight = true;
      } else {
        this.changePage(this.currentPage);
      }
    },

    mobileShowLibrary() {
      this.isMobileClickCreate = true;
      this.isLeft = true;
      this.isCenter = false;
      this.isRight = false;
    },

    handleCreate(){
      this.$router.push('/NewActivity');
    },

    mobileCreatePost(val) {
      if (val) {
        this.isMobileClickCreate = false;
        this.isLeft = false;
        this.isCenter = true;
        this.isRight = false;
      }
    },

    getEachDM(val) {
      this.arrobj_dmList = [];
      this.arrobj_dmList.push(val);
      this.changePage('dm');
    },

    changeToPlannerProgress(val) {
      this.changePage('plannerProgress');
      this.obj_ppData = val;
    },

    checkMobileHideShow() {
      if (this.checkMobileStatus) {
        this.isLeft = false;
        this.isRight = false;
      } else {
        // this.isLeft = true;
        // this.isRight = true;
        this.changePage(this.currentPage);
      }
    },


    /*#region Page tour*/
    broadcastPageVueTourStart() {
      this.$tours['BroadcastPageVueTourName'].start();
    },

    broadcastPageVueTourCallBacksPreviousSteps(currentStep) {
      let finalSteps = currentStep - 1;
    },

    broadcastPageVueTourCallBacksNextSteps(currentStep) {
      let finalSteps = currentStep + 1;
    },

    feedPageVueTourStart() {
      this.$tours['FeedPageVueTourName'].start();
    },

    feedPageVueTourCallBacksPreviousSteps(currentStep) {
      let finalSteps = currentStep - 1;
    },

    feedPageVueTourCallBacksNextSteps(currentStep) {
      let finalSteps = currentStep + 1;
    },
    /*#endregion*/

    async broadcastAlertChangePage(val) {
      this.paramBroadcastAlert = val.hasAlert;
      // await this.changePage(val.pageType);
    },

    async uploadVideo() {
      const {
        selectedFile,
        passtaparent,
        tags,
        tagClassID,
        tagLevelID,
        PostID,
        allowComment,
        passdevelopmentgoals,
        passkeytags,
        postStatus,
        isAllLevel,
        isAllClasses,
        posttitle,
        postType
      } = this.$route.params || {};

      let newStatus;
      if(postStatus !== 'Draft' && postStatus !== 'Template'){
        newStatus = 'Approved'
      }else{
        newStatus = postStatus
      }
      try {
        const saveResponse = await DataSource.shared.savePostUpdate(selectedFile, encodeURIComponent(passtaparent),
            tags, tagClassID, tagLevelID, PostID, allowComment,
            passdevelopmentgoals, passkeytags,
                newStatus, isAllLevel, isAllClasses, posttitle, postType);

        if (saveResponse) {
          switch (saveResponse.code) {
            case "1":
              this.$notify({
                title: lang('Success'),
                message: lang('Upload complete, please refresh to view post.'),
                type: 'success'
              });

              await DataSource.shared.softDeletePost(PostID);

              break;
            case "88":
              this.$vs.loading.close();
              this.$notify.error({
                title: lang('Error'),
                message: lang('Please Login to submit post')
              });
              this.systemmsgError = true;
              break;
            case "99":
              this.$vs.loading.close();
              this.$notify.error({
                title: lang('Error'),
                message: lang('Please fill in content')
              });
              break;
          }//switch
        }
      } catch (e) {
        console.log("upload video err", e);
      }
    }
  },
  ready() {
    if (this.$route.params.selectedFile) {
      this.uploadVideo();
    }
  },
  mounted() {
    this.isMobile();
    this.checkMobileHideShow();
    this.currentPage = "feed";
    this.obj_SelectedComponent = activityFeed;

    if (this.$route.params.portfolioID !== undefined) {
      this.changePage('moment');
      this.portfolioID = this.$route.params.portfolioID;
    } else if (this.$route.query.portfolioid !== undefined) {
      this.changePage('moment');
      this.portfolioID = this.$route.query.portfolioid;
    } else if (this.$route.query.termlyreportid !== undefined) {
      this.changePage('report');
    }

    if (this.$route.query.currentType !== undefined) {
      if (this.$route.query.currentType === "Update") {
        this.changePage('feed');
      } else if (this.$route.query.currentType === "Broadcast") {
        this.changePage('broadcast');
      }
    }

    if (this.$route.query.tour === 'event') {
      this.tourType = "event";
      this.changePage('event');
    } else if (this.$route.query.tour === 'broadcast') {
      this.changePage('broadcast');
      this.broadcastPageVueTourStart();
      this.tourIDName1 = "v-step-broadcastCreateNewBroadcast";
      this.tourIDName2 = "v-step-broadcastEditBroadcast";
    } else if (this.$route.query.tour === 'feed') {
      this.changePage('feed');
      this.feedPageVueTourStart();
      this.tourIDName1 = "v-step-feedCreateNewFeed";
      this.tourIDName2 = "v-step-feedEditFeed";
    } else if (this.$route.query.tour === 'moment') {
      this.tourType = "moment";
      this.changePage('moment');
    } else if (this.$route.query.tour === 'momentEdit') {
      this.tourType = "momentEdit";
      this.changePage('moment');
    } else if (this.$route.query.tour === 'planner') {
      this.tourType = "planner";
      this.changePage('planner');
    } else if (this.$route.query.tour === 'classPlanner') {
      this.tourType = "classPlanner";
      this.changePage('classplanner');
    } else if (this.$route.query.tour === 'termlyreport') {
      this.tourType = "termlyreport";
      this.changePage('report');
    } else if (this.$route.query.tour === 'termlyreportEdit') {
      this.tourType = "termlyreportEdit";
      this.changePage('report');
    }

    const self = this;
  },
};
</script>

<style scoped>
#staffMainPage {
  margin: 0px;
  padding: 0px;
  min-height: calc(100vh - 70px);
}

.nav-button-container {
  margin-bottom: 30px;
}

.web-view .main-content-container.specific {
  padding: 0px;
  margin: 0px;
}

.web-view .main-content-container {
  /*padding: 20px 40px;*/
  /*margin: 0px;*/
  /*text-align: left;*/
}

/* .left-content-container {
    width: 20%;
    display: inline-block;
    position: sticky;
    top: 0px;
    border-radius: 8px;
    vertical-align: top;
    align-self: flex-start;
    min-height: calc(100vh - 70px);
} */

.left-content-container,
.right-content-container {
  /*width: 325px;*/
  width: 20%;
  display: inline-block;
  background: white;
  position: sticky;
  top: 0px;
  border-radius: 8px;
  vertical-align: top;
  align-self: flex-start;
  min-height: calc(100vh - 70px);
}

.center-content-container {
  vertical-align: top;
  display: inline-block;
}

.web-view .center-content-container.normal {
  width: calc(100% - 40%);
}

.web-view .center-content-container.only-left {
  width: calc(100% - 20%);
}

.web-view .center-content-container.full-width {
  width: 100%;
}

.sans-font-style--size-12 {
  font-family: sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 15px;
}
</style>

<style>
img {
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
}

.staffMainPage .menu-box-wrap {
  display: none;
}

.staffMainPage #main-content {
  padding: 0px;
}

.staffMainPage .el-select-dropdown {
  width: 50%;
}

.staffMainPage .el-select-dropdown__item {
  overflow: unset;
  white-space: pre-wrap;
  height: auto;
  text-overflow: unset;
}

.staffMainPage u {
  text-decoration: underline;
}
</style>